// frontend/src/ReleaseNotes/pages/ReleaseNotesPublicPage.tsx
import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mantine/core";
import { ReleaseNotesPublicFilters } from "./ReleaseNotesPublicFilters";
import { ReleaseNotesPublicList } from "../ReleaseNotesPublicList";
import {
  useGetMultiplacerReleaseNotesPublishedQuery,
  useGetMultiplacerReleaseNotesStatusQuery,
  usePostMultiplacerReleaseNotesMarkSeenMutation,
} from "../../../openapi";

export const ReleaseNotesPublicPage: React.FC = () => {
  const { isError } = useGetMultiplacerReleaseNotesPublishedQuery();

  const { data: status } = useGetMultiplacerReleaseNotesStatusQuery();
  const [markSeen] = usePostMultiplacerReleaseNotesMarkSeenMutation();

  const didMarkSeenRef = useRef(false);

  useEffect(() => {
    // Unngå dobbeltkall (f.eks. React StrictMode i dev)
    if (didMarkSeenRef.current) {
      return;
    }

    const latestReleaseId = status?.latestReleaseId ?? null;
    const hasUnread = Boolean(status?.hasUnread);

    if (!latestReleaseId || !hasUnread) {
      return;
    }

    didMarkSeenRef.current = true;

    void markSeen({ body: { releaseId: latestReleaseId } })
      .unwrap()
      .catch(() => {
        // Ikke spam bruker med feil – status kan oppdatere seg senere
        didMarkSeenRef.current = false; // tillat retry hvis request feiler
      });
  }, [status?.latestReleaseId, status?.hasUnread, markSeen]);

  return (
    <Box style={{ width: "80%", maxWidth: "1200px", margin: "0 auto" }} px="md" py="md">
      {isError === true && <p>Kunne ikke laste release notes</p>}

      <Stack gap="md">
        <ReleaseNotesPublicFilters />

        <Box style={{ minHeight: 600 }}>
          <ReleaseNotesPublicList />
        </Box>
      </Stack>
    </Box>
  );
};
